import template from "./templates/entity/template.html";
import { entityAddOn } from "./templates/entity/entity-add-on.js";
import entityController from "./templates/entity/controller.js";

export default angular
	.module("vesl.extensions.json-schema.entity", [
		"schemaForm",
		entityController
	])
	.run(["$templateCache", function($templateCache) { $templateCache.put("./templates/entity/template.html", template); }])
	.config(entityAddOn)
	.name;
